import React from "react";
import { Modal, Table } from "antd";
import styles from "./styles.module.css";
import BillingBlock from "./BillingBlock";
import { CopyOutlined } from "@ant-design/icons";
import { Button, Collapse, Timeline } from "antd";
import { use } from "react";
import { useEffect } from "react";
import { BreathAPIs } from "../../APIs/BreathAPIs";
import { useState } from "react";
import MakeRefund from "./MakeRefund";
import SesssionControl from "./SesssionControl";
import BillUpdateView from "./BillUpdateView";

const ViewBooking = ({
  modalVisible,
  closeModal,
  selBooking,
  setBookingToView,
  userType,
  timezone,
  convertToTimezone
}) => {
  const [billingData, setBillingData] = useState(null);
  const [bookingVersionHistoryData, setBookingVersionHistoryData] =
    useState(null);
  const [bookingTransaction, setBookingTransaction] = useState(null);
  const handleCancel = () => {
    closeModal();
  };

  const [showBillUpdateEnergyModel, setShowBillUpdateEnergyModel] = useState(false)
  // console.log("selected Booking: ", selBooking)

  useEffect(() => {
    if (modalVisible) {
      getBillingData();
      getBookingVersionHistory();
      getBookingTransaction();
    }
  }, [modalVisible]);

  let getBookingTransaction = async () => {
    try {
      const response = await BreathAPIs.getBookingTransaction(selBooking?._id);
      // console.log("Booking Transaction:", response.data);
      setBookingTransaction(response.data);
    } catch (error) {
      console.error("Error fetching booking transaction:", error);
    }
  };

  let getBillingData = async () => {
    try {
      const response = await BreathAPIs.getBilling(selBooking?._id);
      if(response.status === 200){
        setBillingData(response.data);
      }
    } catch (error) {
      console.error("Error fetching billing data:", error);
      return null;
    }
  };
  const getBookingVersionHistory = async () => {
    try {
      const response = await BreathAPIs.getBookingVersionHistory(
        selBooking?._id
      );
      const bookingLog = JSON.parse(response.data[0].bookingLog);

      setBookingVersionHistoryData(
        bookingLog.map((entry) => {
          return {
            children: `${entry.action}  ${
              entry.timestamp
                ? ` : ${timezone==='localTimezone'?new Date(entry.timestamp).toLocaleString("en-US"):convertToTimezone(entry.timestamp,selBooking?.charger?.location?.timezone)}`
                : ""
            }`,
          };
        })
      );
    } catch (error) {
      console.log(
        "Error while fetching booking version history",
        error.message
      );
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };
  const bookingModificationsColumns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Action timestamp",
      dataIndex: "time",
      key: "time",
      render: (text) => <span>{timezone==='localTimezone'?formatDate(text):convertToTimezone(text,selBooking?.charger?.location?.timezone)}</span>,
    },
    {
      title: "Previous Time",
      dataIndex: "currentTime",
      key: "currentTime",
      render: (currentTime) => (
        <span>
          Start: {timezone==='localTimezone'?formatDate(currentTime?.start):convertToTimezone(currentTime?.start,selBooking?.charger?.location?.timezone)} <br />
          End: {timezone==='localTimezone'?formatDate(currentTime?.end):convertToTimezone(currentTime?.end,selBooking?.charger?.location?.timezone)}
        </span>
      ),
    },
    {
      title: "New Time",
      dataIndex: "newTime",
      key: "newTime",
      render: (newTime) => (
        <span>
          Start: {timezone==='localTimezone'?formatDate(newTime?.start):convertToTimezone(newTime?.start,selBooking?.charger?.location?.timezone)} <br />
          End: {timezone==='localTimezone'?formatDate(newTime?.end):convertToTimezone(newTime?.end,selBooking?.charger?.location?.timezone)}
        </span>
      ),
    },
  ];

  const selectedData =
    selBooking?.bookingStatus === "Cancelled" ? null : billingData;
  const energyCost =
    (selectedData?.totalCost || 0.0) -
    (selBooking?.unUtilizedFee || 0.0) -
    (selectedData?.taxCost || 0.0);

  return (
    <Modal
      title={
        <div>
          <div className={styles['view-booking-title']}>
            <h5>View Booking</h5>
            {(new Date(selBooking?.endTime) < new Date() && selBooking?.bookingStatus === 'Inprogress') ?
              <button type="button" className={styles['bill-update-btn']} onClick={()=>{setShowBillUpdateEnergyModel(true)}}>Update Bill</button> : ""}
          </div>
          {/* {console.log("selcted charger timezone : ", selBooking)} */}
          <div><h6>{timezone}  {timezone === 'localTimezone' ? '' :  `(${selBooking?.charger?.location?.timezone})`}</h6></div>
        </div>
      } 
      
      open={modalVisible}
      onCancel={handleCancel}
      footer={null}
      width={window.innerWidth <= 768 ? "100%" : "50%"}
    >
      
      <div className={styles["edit-booking-top"]}>
        <div>
          ID : <b>{selBooking?._id}</b>
        </div>
        <div>
          Time :{" "}
          <b>
            {timezone==='localTimezone'?formatDate(selBooking?.startTime):convertToTimezone(selBooking?.startTime,selBooking?.charger?.location?.timezone)} -{" "}
            {timezone==='localTimezone'?formatDate(selBooking?.isNightCharging ? selBooking?.endTimeOverNight : selBooking?.endTime):convertToTimezone(selBooking?.isNightCharging ? selBooking?.endTimeOverNight : selBooking?.endTime,selBooking?.charger?.location?.timezone)}
          </b>
        </div>
        <div>
          User :{" "}
          <b>
            {selBooking?.user?.firstName + " " + selBooking?.user?.lastName}
          </b>
        </div>
        <div>
          Email : <b>{selBooking?.user?.email}</b>
        </div>
        <div>
          Charger :{" "}
          <b>
            {selBooking?.charger?.chargerTag} ({selBooking?.charger?._id})
          </b>{" "}
        </div>
        <div>
          Location :{" "}
          <b>
            {selBooking?.charger?.location?.locationName} (
            {selBooking?.charger?.location?._id})
          </b>{" "}
        </div>
        <div>
          Sessions: <b>{selBooking?.sessions?.length}</b>
        </div>

        <div>
          Estimated amt :
          <span>
            <Button
              icon={
                <CopyOutlined
                  style={{ border: "none", backgroundColor: "none" }}
                />
              }
              onClick={() =>
                navigator.clipboard.writeText(selBooking?.estimateAmount || 0.0)
              }
              style={{ marginLeft: 8, marginRight: 8 }}
              size="small"
            />
            <b>{selBooking?.estimateAmount?.toFixed(2)}</b>
          </span>
        </div>

        <div>
          Booking Ended:{" "}
          <b>{selBooking?.bookingEnded === true ? "Yes" : "False"}</b>
        </div>
        <div>
          Session Active:{" "}
          <b>{selBooking?.isSessionActive === true ? "Yes" : "False"}</b>
        </div>
        <div>
          Booking Status: <b>{selBooking?.bookingStatus}</b>
        </div>
        <div>
          Booking Type: <b>{selBooking?.bookingType}</b>
        </div>
        <div>
          Booking Allocation Algorithm: <b>{selBooking?.allocationAlgorithm}</b>
        </div>
        
          {
            selBooking?.bookingStatus==='Cancelled' &&
            (
              <div>
                Cancellation Fee Charged : <b>{bookingTransaction?.[0]?.amount?.toFixed(2) || (0).toFixed(2)}</b>
              </div>
            )
          }
        
        <div>
          Unutilized Time Fee :
          <b>
            <Button
              icon={<CopyOutlined />}
              onClick={() =>
                navigator.clipboard.writeText(selBooking?.unUtilizedFee || 0.0)
              }
              style={{ marginLeft: 8, marginRight: 8 }}
              size="small"
            />
            {selBooking?.unUtilizedFee?.toFixed(2)}
          </b>
        </div>
        
        <div>
          Energy Cost :
          <b>
            <Button
              icon={<CopyOutlined />}
              onClick={() => navigator.clipboard.writeText(energyCost || 0.0)}
              style={{ marginLeft: 8, marginRight: 8 }}
              size="small"
            />
            {energyCost?.toFixed(2)}
          </b>
        </div>

        {selBooking?.isNightCharging && <div>
          Overnight Fee :
          <b>
            <Button
              icon={<CopyOutlined />}
              onClick={() =>
                navigator.clipboard.writeText(selBooking?.nightChargeEstimate >= 0 ? selBooking?.nightChargeEstimate?.toFixed(2) : "0.00")
              }
              style={{ marginLeft: 8, marginRight: 8 }}
              size="small"
            />
            {selBooking?.nightChargeEstimate >= 0 ? selBooking?.nightChargeEstimate?.toFixed(2) : "0.00"}
          </b>
        </div>}

        <div>
          Total Cost ( Energy Cost + Unutilized Time Fee + Tax ) :
          <span>
            <Button
              icon={<CopyOutlined />}
              onClick={() =>
                navigator.clipboard.writeText(selBooking?.totalCost || 0.0)
              }
              style={{ marginLeft: 8, marginRight: 8 }}
              size="small"
            />
            <b>{selBooking?.totalCost?.toFixed(2)}</b>
          </span>
        </div>
        {selBooking?.bookingStatus === "Completed" && (
          <>
            <div>
              Idle Fees:
              <span>
                <Button
                  icon={<CopyOutlined />}
                  onClick={() =>
                    navigator.clipboard.writeText(billingData?.IdleCost || 0.0)
                  }
                  style={{ marginLeft: 8, marginRight: 8 }}
                  size="small"
                />
                <b>{billingData ? billingData?.IdleCost.toFixed(2) : "0.0"}</b>
              </span>
            </div>

            <div>
              Grand Total:
              <span>
                <Button
                  icon={<CopyOutlined />}
                  onClick={() =>
                    navigator.clipboard.writeText(
                      billingData?.grandTotal || 0.0
                    )
                  }
                  style={{ marginLeft: 8, marginRight: 8 }}
                  size="small"
                />
                <b>{billingData?.grandTotal.toFixed(2)}</b>
              </span>
            </div>
          </>
        )}

        <Collapse
          style={{ display: "block", padding: "10px" }}
          items={[
            {
              key: "1",
              label: "Booking History",
              children: (
                <div>
                  <Timeline
                    pending={selBooking?.isSessionActive && "Session Active"}
                    items={bookingVersionHistoryData}

                  />
                </div>
              ),
            },
          ]}
        />

        {selBooking?.bookingModifications?.length > 0 && (
          <div className={styles["modifications-section"]}>
            <h6>Booking Modifications</h6>
            <Table
              dataSource={selBooking.bookingModifications}
              columns={bookingModificationsColumns}
              rowKey={(record, index) => index}
              pagination={false}
              size="small"
              rowClassName={(record) =>
                record.type === "initiate-now" ? styles["gray-row"] : ""
              }
              bordered
            />
          </div>
        )}
        {new Date(selBooking.startTime) <= new Date() &&
          new Date(selBooking.endTime) >= new Date() &&
          (selBooking?.bookingStatus === "Inprogress" ||
            selBooking?.bookingStatus === "Upcoming") &&
          userType === "Admin" && (
            <Collapse
              style={{ display: "block", padding: "10px" }}
              items={[
                {
                  key: "1",
                  label: "Session Control",
                  children: (
                    <div>
                      <SesssionControl selectedBooking={selBooking} />
                    </div>
                  ),
                },
              ]}
            />
          )}
      </div>
      {/* {
                console.log("Sel booking times",new Date(selBooking.startTime), new Date(selBooking.endTime) , new Date(selBooking.startTime) <= new Date() && new Date(selBooking.endTime) >= new Date())
            } */}
      {/* {console.log("Selc booking",selBooking)} */}
      {((selBooking?.bookingStatus === "Cancelled" &&
        bookingTransaction?.length > 0) ||
        (selBooking?.bookingStatus === "Completed" && billingData)) &&
        selBooking && (
          <MakeRefund
            bookingId={selBooking?._id}
            selUser={selBooking?.user}
            bookingStatus={selBooking?.bookingStatus}
            estimateAmount={selBooking?.estimateAmount}
            unUtilizedFee={selBooking?.unUtilizedFee}
            billingDataProp={
              selBooking?.bookingStatus === "Cancelled" ? null : billingData
            }
            setBookingToView={setBookingToView}
            isRefunded={selBooking?.isRefunded}
            refundAmounts={selBooking?.refundAmounts || [0, 0, 0, 0, 0]} // [energy(with tax), unutilized fee, idle fee, cancellation fee, night charging fee]
            isNightCharging={selBooking?.isNightCharging || false}
            nightChargeEstimate={selBooking?.nightChargeEstimate || 0}
          />
        )}
      {selBooking?.bookingStatus === "Completed" && billingData && (
        <div>
          <BillingBlock
            bookingId={selBooking?._id}
            unUtilizedFee={selBooking?.unUtilizedFee}
            idleDuration={selBooking?.IdleDuration}
            unUtilizedTimeSec={selBooking?.unUtilizedTime?.total}
            billingDataProp={billingData}
          />
        </div>
      )}

      {showBillUpdateEnergyModel && <Modal open={showBillUpdateEnergyModel} onCancel={()=>{setShowBillUpdateEnergyModel(false)}} footer={null}>
        <BillUpdateView selectedBooking={selBooking} setShowBillUpdateEnergyModel={setShowBillUpdateEnergyModel} showBillUpdateEnergyModel={showBillUpdateEnergyModel}/>
      </Modal>}
    </Modal>
  );
};

export default ViewBooking;
